import type { RecursiveRequired, Settings } from '#/global'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'
import { cloneDeep } from 'es-toolkit'

const globalSettings: Settings.all = {
  app: {
    themeSync: false,
    lightTheme: 'orange',
    darkTheme: 'green',
    enablePermission: true,
    enableCheckUpdates: false,
  },
  menu: {
    mode: 'head',
  },
  topbar: {
    mode: 'fixed',
  },
  toolbar: {
    notification: true,
    i18n: true,
    pageReload: true,
    cloudResources: true,
  },
  mainPage: {
    enableHotkeys: false,
  },
  navSearch: {
    enableHotkeys: false,
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
